<app-modal class="lifecycle-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.tools.details.detailsPage.modals.toolSpecialIdentifiersEditModal.title' | translate }}</h5>
    </ng-container>
    <div class="body" modal-body>
        <app-special-identifiers-form
            *ngIf="toolDetails && !isLoading"
            [toolDetails]="toolDetails">
        </app-special-identifiers-form>
    </div>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="isLoading"
                    (click)="clickUpdate()">
            {{ 'generic.buttons.update'| translate }}
        </app-button>
    </div>
</app-modal>
